import TabPanel, { TabPanelProps } from "@mui/lab/TabPanel";

import DatasetLegend from "./DatasetLegend";
import Timeline from "./Timeline";
import { Patient } from "../models/patient";
import { Spacer } from "./primitives/Spacer";
import { useAppContext } from "../context/AppContext";
import { useVisualisationData } from "../hooks/useVisualisationData";

export const TimelineTab: React.FC<TabPanelProps & { patient: Patient }> = ({
  patient,
  ...tabPanelProps
}) => {
  const { dataConfig } = useAppContext();
  const { dataset, patientData, series } = useVisualisationData({
    exportId: dataConfig.exportId || undefined,
    patientId: patient.id,
  });
  const { medicaments, weeklyTargets } = patientData?.data || {};

  return (
    <TabPanel {...tabPanelProps} sx={{ "&": { py: "0 !important" } }}>
      <Timeline
        dataset={dataset}
        series={series}
        references={{
          medicaments: medicaments || [],
          weeklyTargets: weeklyTargets || [],
        }}
      />
      <Spacer />
      <DatasetLegend
        series={series}
        sx={({ spacing }) => ({
          bottom: spacing(2),
          position: "sticky",
          zIndex: 1000,
        })}
        isExtrasVisible={false}
      />
    </TabPanel>
  );
};

export default TimelineTab;
